interface ICoordinate {
  x: number
  y: number
  z?: number
}

type RadToDegree = (rad: number) => number

type GetBearingBetweenPoints = (
  origin: ICoordinate,
  destination: ICoordinate
) => number

type GetSuitablyValueBetweenBearings = (
  newBearing: number,
  currentBearing: number
) => number

const radToDegree: RadToDegree = (rad) => rad * (180 / Math.PI)

export const getBearingBetweenPoints: GetBearingBetweenPoints = (
  origin,
  destination
) => {
  const twoPI = Math.PI * 2

  if (origin.x === destination.x && origin.y === destination.y) return
  let theta = Math.atan2(destination.x - origin.x, destination.y - origin.y)

  if (theta < 0.0) theta += twoPI

  return Math.floor(radToDegree(theta))
}

export const getSuitablyValueBetweenBearings: GetSuitablyValueBetweenBearings =
  (newBearing, currentBearing) => {
    const difference = Math.abs(newBearing - currentBearing)

    // Adjust newBearing to ensure the shortest direction
    if (difference > 180)
      return newBearing > 0 ? newBearing - 360 : newBearing + 360

    return newBearing // Return as is if the difference is within limits
  }

type Direction8 = "N" | "NE" | "E" | "SE" | "S" | "SW" | "W" | "NW"

const OCTANTS: Direction8[] = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"]

type GetOctantFromBearing = (bearing: number) => Direction8
export const getOctantFromBearing: GetOctantFromBearing = (bearing) => {
  const normalized = ((bearing % 360) + 360) % 360
  const index = Math.round(normalized / 45) % 8
  return OCTANTS[index]
}
